import { Scene, Input } from "phaser";
import FullScreen from "../../phaser/components/fullScreen";


export default class GameOver extends Scene {

    constructor() {
        super({ key: "GameOver" });
    }
    init(data) {
        this.level = data.level;
        this.characterSelected = data.characterSelected;
        this.lastCoordenates = data.lastCoordenates;
    }

    preload() {
        let file = 'thick_8x8'; // Nombre base de tu fuente
        this.load.bitmapFont('pixelfont', 'fonts/' + file + '.png', 'fonts/' + file + '.xml');
    
        if (this.sys.game.device.os.desktop) {
            this.isMobile = false;
        }
        else {
            this.isMobile = true;
        }


    }
    create() {
        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.buttonFullscreen = new FullScreen(this);
        const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        const screenCenterY = this.cameras.main.worldView.y + this.cameras.main.height / 2;
        // this.text = this.add.text(screenCenterX, screenCenterY, 'TRY AGAIN . . .', { font: "35px CustomFont", fill: "#BA2A28" }).setOrigin(0.5);

        if(this.level === 7) {
            this.add.bitmapText(screenCenterX, screenCenterY, 
                'pixelfont', `And now, I'm in my deja vu . . .`.toUpperCase(), 30).setTint(0xBA2A28).setDepth(1).setOrigin(0.5); 
        } else {
            this.add.bitmapText(screenCenterX, screenCenterY, 
                'pixelfont', 'TRY AGAIN . . .'.toUpperCase(), 30).setTint(0xBA2A28).setDepth(1).setOrigin(0.5); 
        }

        setTimeout(() => {
            this.scene.start(`Hallway`, { characterSelected: this.characterSelected, loadAgain: true, lastCoordenates: this.lastCoordenates });
        }, 3000);

    }

    
    update() {


    }


}